import {ApiReturnType} from "../../models/common/ApiReturnType";
import {Office} from "../../models/common/Office";
import {  StateObservable, ofType } from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {getViewSettingsSafely, ViewIdentifiable} from "../../models/common/ViewSettings";
import {
    FETCH_USER_VIEW_SETTINGS_SUCCESS,
    HANDLE_SEARCH_TRIGGERED,
    VIEW_SORT_CHANGE, ViewActionTypes
} from "../common/UserViewSettingsActions";
import {getUrlParamsFromViewSettings, RouteConfig} from "../../config/RouteConfig";
import { filter, mergeMap, map, catchError } from "rxjs/operators";
import {APP_CONFIG} from "../../config/GeneralConfig";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';
import {eventNotificationShow} from "../common/EventNotificationActions";
import {EVENT_NOTIFICATION_TYPE} from "../../helpers/EventNotificationType";


/**
 * office action types
 */
export type EmployerOfficeActionTypes = FetchEmployerOfficesActionTypes

/**
 * fetch office of employers
 **/
export interface FetchEmployersOfficesAction extends ViewIdentifiable {
    type: typeof FETCH_EMPLOYERS_OFFICES
    employersId: number
}

export interface FetchEmployersOfficesSuccessAction extends ViewIdentifiable {
    type: typeof FETCH_EMPLOYERS_OFFICES_SUCCESS
    payload: ApiReturnType< Office[] >
}

export interface FetchEmployersOfficesErrorAction extends ViewIdentifiable {
    type: typeof FETCH_EMPLOYERS_OFFICES_ERROR
    error: Error
}

export type FetchEmployerOfficesActionTypes = FetchEmployersOfficesAction | FetchEmployersOfficesSuccessAction | FetchEmployersOfficesErrorAction

export const FETCH_EMPLOYERS_OFFICES = "FETCH_EMPLOYERS_OFFICES";
export const FETCH_EMPLOYERS_OFFICES_SUCCESS = "FETCH_EMPLOYERS_OFFICES_SUCCESS";
export const FETCH_EMPLOYERS_OFFICES_ERROR = "FETCH_EMPLOYERS_OFFICES_ERROR";

export const fetchEmployersOffice = ( employersId: number, viewIdentifier: string ): FetchEmployersOfficesAction =>
    ({ type: FETCH_EMPLOYERS_OFFICES, employersId, viewIdentifier });
export const fetchEmployersOfficesSuccess = ( payload: ApiReturnType< Office[] >, viewIdentifier: string ): FetchEmployersOfficesSuccessAction =>
    ({ type: FETCH_EMPLOYERS_OFFICES_SUCCESS, payload, viewIdentifier });
export const fetchEmployersOfficesError = ( error: Error, viewIdentifier: string ): FetchEmployersOfficesErrorAction =>
    ({ type: FETCH_EMPLOYERS_OFFICES_ERROR, error, viewIdentifier });

export const fetchEmployersOfficesEpic = (
    action$: Observable< FetchEmployersOfficesAction | ViewActionTypes >,
    store$: StateObservable<AppState>
) =>
    action$.pipe(
        ofType( VIEW_SORT_CHANGE, FETCH_EMPLOYERS_OFFICES, HANDLE_SEARCH_TRIGGERED, FETCH_USER_VIEW_SETTINGS_SUCCESS ),
        filter( action  => action.viewIdentifier === RouteConfig.employersOffice.viewIdentifier ),
        mergeMap( action => {
            const userViewSettings = getViewSettingsSafely( action.viewIdentifier, store$ );
            const path = `${ APP_CONFIG.baseWeb }employers/offices/${ getUrlParamsFromViewSettings( userViewSettings ) }`;

            return ajax( APP_CONFIG.getRequestObject(path) ).pipe(
                map( response => fetchEmployersOfficesSuccess(
                    response.response as ApiReturnType< Office[] >,
                    action.viewIdentifier
                ) ),
                catchError( error => of(
                    fetchEmployersOfficesError( error, action.viewIdentifier ),
                    eventNotificationShow(
                        EVENT_NOTIFICATION_TYPE.customAjaxError,
                        "Standorte des Arbeitgebers konnten nicht geladen werden!"
                    )
                ) )
            );

        })
    );
